<template>
  <div am-collumn-options class="_display:flex _justify-content:space-between _align-items:center"
    :style="column.filtering ? 'background-color: rgba(255, 200, 0, 0.25); border-radius: 4px; padding: 0 4px;' : ''"
  >
    <div am-column-name :title="column.name">
      {{ column.name }}
    </div>
    <svg
      v-if="column.category !== 'children' && column.category !== 'image'"
      @click="isOpenCollumnOptions = !isOpenCollumnOptions"
      v-click-outside="() => isOpenCollumnOptions = false"
      viewBox="0 0 24 24"
      am-icon
      :style="`fill: ${inkline.options.colorMode === 'dark' || darkMode ? 'white' : 'black'}`"
    >
      <use xlink:href="@/assets/icons.svg#arrow_down" x="0" y="0" width="24" height="24"></use>
    </svg>
    <i-card
      v-if="isOpenCollumnOptions"
      am-options
    >
      <template v-if="column.category === 'field' || column.type === 'id'">
        <div
          am-option
          class="_display:flex _align-items:center"
          @click="store.dispatch('filter/sortPartsAZ', {
            subtable: $route.params.subtable,
            colIndex: column.colIndex,
            isSortAz: true
          })"
        >
          <svg
            viewBox="0 0 24 24"
            am-icon
            :style="`fill: ${inkline.options.colorMode === 'dark' || darkMode ? 'white' : 'black'}`"
            class="_margin-right:1/2"
          >
            <use xlink:href="@/assets/icons.svg#sort_up" x="0" y="0" width="24" height="24"></use>
          </svg>
          <p class="_margin:0 _font-size:sm">Sort A -> Z</p>
        </div>
        <div
          am-option
          class="_display:flex _align-items:center"
          @click="store.dispatch('filter/sortPartsAZ', {
            subtable: $route.params.subtable,
            colIndex: column.colIndex,
            isSortAz: false
          })"
        >
          <svg
            viewBox="0 0 24 24"
            am-icon
            :style="`fill: ${inkline.options.colorMode === 'dark' || darkMode ? 'white' : 'black'}`"
            class="_margin-right:1/2"
          >
            <use xlink:href="@/assets/icons.svg#sort_up" x="0" y="0" width="24" height="24"></use>
          </svg>
          <p class="_margin:0 _font-size:sm">Sort Z -> A</p>
        </div>
      </template>
      <div
        am-option
        class="_display:flex _align-items:center"
        @click="showFilter()"
      >
        <svg
          viewBox="0 0 24 24"
          am-icon
          :style="`fill: ${inkline.options.colorMode === 'dark' || darkMode ? 'white' : 'black'}`"
          class="_margin-right:1/2"
        >
          <use xlink:href="@/assets/icons.svg#filter" x="0" y="0" width="24" height="24"></use>
        </svg>
        <p class="_margin:0 _font-size:sm">Filter by this field</p>
      </div>
    </i-card>
  </div>
</template>

<script setup>
import { ref, defineProps, computed, inject } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
const route = useRoute()
const store = useStore()
const isOpenCollumnOptions = ref(false)
const inkline = inject('inkline')
const prop = defineProps({
  column: {
    type: Object,
    required: true
  }
})
const darkMode = computed(() => {
  if (document.body.classList.contains('-dark')) {
    return true
  } else return false
})
const showFilter = () => {
  store.state.filter.isShowFilter = true
  store.dispatch('filter/selectCol', {
    col: prop.column,
    subtable: route.params.subtable
  })
}
</script>

<style lang="scss">
[am-collumn-options] {
  [am-column-name] {
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: calc(100% - 10px);
  }
  .card.-light {
    ----border-top-color: var(--color--light-40);
    .card-body {
      background-color: var(--color--light-40);
      padding: 10px;
    }
    [am-option]:hover {
      background-color: var(----body--background);
    }
  }
  .card.-dark {
    ----border-top-color: var(--color--dark-40);
    .card-body {
      background-color: var(--color--dark-40);
      padding: 10px;
    }
    [am-option]:hover {
    background-color: var(----body--background);
  }}
  [am-options] {
    min-width: 10.5rem;
    width: 100%;
    position: absolute;
    left: 0;
    top: 100%;
    z-index: 3;
    // .card-body {
    //   background-color: var(--color--dark-40) !important;
    // }
    [am-option] {
      cursor: pointer;
      padding: 5px;
    }
  }
}
</style>
